import { apiClient } from '../client';
import { UpdatePurchaseRequestBodyDTO,PurchaseRequestDetails } from '../../../contract/dtos/purchaseRequest';
import { GetPurchaseRequestListingsParams } from '../../../contract/dtos/purchaseRequest';

export const updatePurchaseRequest = async (branchId: string, componentId: string, tenantId: string, body: UpdatePurchaseRequestBodyDTO) => {
    const response = await apiClient.post(`/corporate/v1/branch/${branchId}/pr?component_id=${componentId}&tenant_id=${tenantId}`, body);
    return response.data;
};

export const deletePurchaseRequestItem = async (branchId: string, itemId: string, componentId: string, tenantId: string) => {
  const response = await apiClient.delete(`/corporate/v1/branch/${branchId}/pr-item/${itemId}?component_id=${componentId}&tenant_id=${tenantId}`);
  return response.data;
};

export const getDraftPurchaseRequest = async (branchId: string, componentId: string, tenantId: string): Promise<PurchaseRequestDetails> => {
  const response = await apiClient.get(`/corporate/v1/branch/${branchId}/pr?component_id=${componentId}&tenant_id=${tenantId}`);
  return response.data;
};

export const getPurchaseRequestById = async (id: string, componentId: string, tenantId: string, branchId: string): Promise<PurchaseRequestDetails> => {
  const response = await apiClient.get(`/corporate/v1/pr/${id}?component_id=${componentId}&tenant_id=${tenantId}&branch_id=${branchId}`);
  return response.data;
};

export const getPurchaseRequestListings = async (params: GetPurchaseRequestListingsParams) => {
  const response = await apiClient.get('/corporate/v1/pr', {
    params: {
      component_id: params.componentId,
        tenant_id: params.tenantId,
        branches_ids: params.branchesIds,
        status: params.status,
        page: params.page,
        size: params.size,
        sort: params.sort,
        has_purchase_order: params.has_purchase_order,
    }
  });
  
  const total = parseInt(response.headers['x-total-count'] || '0', 10);

  return {
    total,
    data: response.data,
  };
};

export const submitPurchaseRequest = async (id: string, componentId: string, tenantId: string, branchId: string) => {
  const response = await apiClient.post(`/corporate/v1/pr/${id}?component_id=${componentId}&tenant_id=${tenantId}&branch_id=${branchId}`);
  return response.data;
};



